import { getPaginatedList } from 'shared/api'

export const doLoad = async props => {
  return await getPaginatedList('/public/articles/feed', {
    ...props,
    filters: [{ name: 'type', value: 'StaffPick' }],
  })
}
